import { useEffect, useState } from 'react';
import './css/header/HeaderPrincipal.css';
import { Routes, Route, useNavigate } from "react-router-dom";
import { PageList } from './enums-lists/PagesList';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './redux/store';
import { IPublicClientApplication } from '@azure/msal-browser';
import { CustomNavigationClient } from "./services/msal/CustomNavigationClient";
import { MsalProvider } from '@azure/msal-react';
import { MainProps, UserState } from './types-interfaces/interfaces';
import LoginSSRR from './pages/LoginSSRR';
import HeaderPrincipal from './components/header/HeaderPrincipal';
import { msalInstance } from '.';
import ConsultaPagos from './pages/ConsultaPagos';
import DomGuardian from './components/guardian/DomGuardian';
import { fetchCheckAuth, setLoginInProcess, setUserValue } from './redux/slices/user/userSlice';

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  const [checkAPI, setCheckAPI] = useState<boolean>(true);
  const main = useSelector<RootState, MainProps>((state) => state.mainState);
  const userState: UserState = useSelector<RootState, UserState>((state) => state.userState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  //TODO: revisar estadoNombre
  //eslint-disable-next-line
  const accounts = msalInstance.getAllAccounts();

  useEffect(() => {
    if ((accounts.length === 0 && !userState.loginInProcess) || userState.expiredToken?.status) {
      dispatch(setUserValue({name:'name', value: ''}));
      navigate('/');
    }
    if (accounts.length) {
      dispatch(setLoginInProcess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userState]);

  function handleMouseMove(ev: React.MouseEvent<HTMLDivElement>) { 
    if (checkAPI && userState.currentSession?.accessToken) {
      dispatch(fetchCheckAuth(userState));
      setCheckAPI(false);
    }
  }

  if (userState.currentSession?.isAuthenticated && accounts.length > 0){
    return (    
      <MsalProvider instance={pca}>    
        <div className="App" onMouseMove={(ev)=> handleMouseMove(ev)}>            
            <HeaderPrincipal
              className="header-principal"
              textLinks={PageList}
              breadCrumbs={main.breadCrumbs}
              instance={pca}
              setCheckAPI={setCheckAPI}
            />
            <Routes>
              <Route path='/' element={<DomGuardian element={<ConsultaPagos className='consulta-pagos'/>} profileAllowed={[1,2]}/>} />
              { PageList && PageList.length > 0 &&
                PageList.map((page,index) => <Route key={'r' + index} path={page.url} element={<DomGuardian element={page.element} profileAllowed={page.profiles}/>} />)}
            </Routes>
          </div>      
      </MsalProvider>    
    );}
    else{
      return (    
        <MsalProvider instance={pca}>      
          <div className="App">
              <Routes>
                <Route path='/' element={<LoginSSRR/>} />
                { PageList && PageList.length > 0 &&
                  PageList.map((page,index) => <Route key={'r' + index} path={page.url} element={<DomGuardian element={page.element} profileAllowed={page.profiles}/>} />)}
              </Routes>
            </div>
        </MsalProvider>
      );
    }
}

export default App;